import { NgModule }                     from '@angular/core';
import { FormDatepickerModule }         from '@shared/form-elements/form-datepicker/form-datepicker.module';
import { FormDateRangePickerComponent } from '@shared/form-elements/form-daterangepicker/form-date-range-picker.component';
import { FormElementsModule }           from '@shared/form-elements/form-elements.module';

@NgModule( {
	declarations: [
		FormDateRangePickerComponent
	],
	imports: [
		FormElementsModule,
		FormDatepickerModule
	],
	exports: [
		FormDateRangePickerComponent
	]
} )
export class FormDateRangePickerModule {}
